<div class="page-title-area">
    <img src="assets/images/emppurchaseprogram_banner.jpeg" alt="Page Background" class="page-bg" style="width: 100%; height: 100%;">
    <div class="container">
        <div class="section-title program-title" style="text-align: left;">
            <h2 style="color: #fff !important; font-weight: 500;">Employee Purchase Program</h2>
            <h4 style="color: #fff !important; font-weight: 200;">Exclusive Employee Offers for Your Organization</h4>
        </div>
    </div>
</div>

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title">
                    <h2>Employee Purchase Program</h2>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="program-content" style="text-align: left; color: #000;">
                    <!-- <h3>Empower Your Workforce</h3> -->
                    <p style="color: #000;">Our Unique Employee Purchase Program are exclusive benefits customised to help organisations enhance their employee experience. By partnering with us, companies can extend special pricing on Apple products, coupled with the convenience of easy monthly instalments. These programs not only offer significant cost savings but also boost employee satisfaction, engagement, and retention. Empower your teams with access to the technology they love—made more accessible than ever.</p>
                   <!--  <ul class="program-features">
                        <li><i class="fas fa-check-circle"></i> Significant cost savings on Apple products</li>
                        <li><i class="fas fa-check-circle"></i> Boost employee satisfaction and retention</li>
                        <li><i class="fas fa-check-circle"></i> Easy monthly instalments available</li>
                        <li><i class="fas fa-check-circle"></i> Seamless program implementation</li>
                    </ul> -->
                </div>
            </div>
            <div class="col-lg-4">
                <div class="program-image">
                    <img src="assets/images/smart_emp1.jpeg" alt="Employee Purchase Program" class="img-fluid" style="width: 100%;">
                </div>
            </div>
        </div>
    </div>
</section>

<section class="benefits-section ptb-100 bg-section">
    <div class="container">
        <div class="section-title animate-fade-down">
            <h2>Employee Benefits</h2>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card animate-card" data-delay="0">
                    <div class="icon">
                        <img src="assets/images/benefits.png" alt="Team Working" class="background-image">
                        <!-- <i class="fas fa-percentage"></i> -->
                    </div>
                    <h3>Special Employee Pricing</h3>
                    <p>Unlock attractive savings on Apple products available only through our employee benefit programs.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card animate-card" data-delay="200">
                    <div class="icon">
                        <img src="assets/images/cash.png" alt="Team Working" class="background-image">
                        <!-- <i class="fas fa-credit-card"></i> -->
                    </div>
                    <h3>Easy Monthly Instalments</h3>
                    <p>Spread the cost with convenient EMIs, making premium devices more affordable than ever.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card animate-card" data-delay="400">
                    <div class="icon">
                        <img src="assets/images/apple.png" alt="Team Working" class="background-image">
                        <!-- <i class="fas fa-laptop"></i> -->
                    </div>
                    <h3>Empowered by Apple</h3>
                    <p>Equip your teams with cutting-edge Apple devices that boost productivity, creativity, and performance.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-card animate-card" data-delay="600">
                    <div class="icon">
                        <img src="assets/images/best-customer-experience.png" alt="Team Working" class="background-image">
                        <!-- <i class="fas fa-headset"></i> -->
                    </div>
                    <h3>Hassle-Free Experience</h3>
                    <p>Enjoy smooth purchasing, setup, and dedicated support—all in one seamless employee journey.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="org-benefits-section ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Benefits to the Organisation</h2>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="benefit-box">
                    <div class="benefit-image">
                        <img src="assets/images/Employee Pricing.png" alt="Team Working" class="background-image">
                    </div>
                    <div class="benefit-icon">
                        <img src="assets/images/handshake.png" alt="Team Working" class="background-image">
                        <!-- <i class="fas fa-handshake"></i> -->
                    </div>
                    <h3>Attract Top Talent with Exclusive Perks</h3>
                    <p>Enhance your employee value proposition by offering exclusive discounts on Apple products—an attractive benefit for both current staff and potential hires.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-box">
                    <div class="benefit-image">
                        <img src="assets/images/boost_emp.jpg" alt="Team Working" class="background-image">
                    </div>
                    <div class="benefit-icon">
                        <img src="assets/images/boost_emp.png" alt="Team Working" class="background-image">
                        <!-- <i class="fas fa-medal"></i> -->
                    </div>
                    <h3>Boost Employee Satisfaction and Retention</h3>
                    <p>Show employees they're valued with meaningful perks, helping increase morale, engagement, and long-term loyalty to your organisation.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-box">
                    <div class="benefit-image">
                        <img src="assets/images/zero_fin.jpg" alt="Team Working" class="background-image">
                    </div>
                    <div class="benefit-icon">
                        <img src="assets/images/zero-commitment.png" alt="Team Working" class="background-image" width="60">
                        <!-- <i class="fas fa-headset"></i> -->
                    </div>
                    <h3>Zero Financial Commitment Required</h3>
                    <p>Offer a high-impact employee benefit without incurring any cost—making it a budget-friendly solution for elevating workplace satisfaction.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="benefit-box">
                    <div class="benefit-image">
                        <img src="assets/images/hasslefree.jpeg" alt="Team Working" class="background-image">
                    </div>
                    <div class="benefit-icon">
                        <img src="assets/images/setup.jpg" alt="Team Working" class="background-image" width="60">

                        <!-- <i class="fas fa-box"></i> -->
                    </div>
                    <h3>Hassle-Free Program Setup</h3>
                    <p>Our programs are designed for quick and seamless implementation, requiring minimal involvement from your HR or admin teams.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="how-it-works-section ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>4 Steps to Get Started</h2>
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="work-step animate-step" data-delay="0">
                    <div class="step-number">1</div>
                    <h3>Program Enrolment</h3>
                    <p>Organisations can join the Employee Purchase Program or Smart Employee Purchase Program by simply reaching out to our team for onboarding support.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="work-step animate-step" data-delay="200">
                    <div class="step-number">2</div>
                    <h3>Program Activation</h3>
                    <p>After enrolment, employees can instantly take advantage of special discounts and flexible payment options available through the program.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="work-step animate-step" data-delay="400">
                    <div class="step-number">3</div>
                    <h3>Wide Product Choice</h3>
                    <p>Team members can browse a diverse range of Apple products and pick what suits their needs—at exclusive employee pricing.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="work-step animate-step" data-delay="600">
                    <div class="step-number">4</div>
                    <h3>Payment & Delivery</h3>
                    <p>Employees select a payment plan that suits them best, and enjoy direct delivery of their Apple products to their chosen address.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container mb-4">
    <div class="d-flex justify-content-end">
        <button class="btn back-btn" (click)="navigateToHome()">
            <i class="fas fa-arrow-left me-2"></i> Back to Home
        </button>
    </div>
</div>